"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLabelDetails = exports.StyledLabel = exports.DecorationComponentContainer = exports.StyleLabelWrapper = exports.Container = exports.StyledLink = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _designTokens = require("@decisiv/design-tokens");

var _Link = _interopRequireWildcard(require("../../../components/Link"));

var _Typography = require("../../../components/Typography");

var _styleModifiers = require("../../../utils/styleModifiers");

var _focusRingWithColor = _interopRequireDefault(require("../../../utils/focusRingWithColor"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var enabledFGColor = _designTokens.color.interaction.pacificOcean;
var disabledFGColor = _designTokens.color.opacity.charcoal40;
var StyledLink = (0, _styledComponents.default)(_Link.default).withConfig({
  displayName: "styles__StyledLink",
  componentId: "sc-1vr9h8x-0"
})(["&&,&&:hover:not(:active),&&:focus:not(:active){text-decoration:none;", ";", ";}"], (0, _Link.linkColorStyles)(enabledFGColor, enabledFGColor, enabledFGColor), (0, _styleModifiers.when)('disabled', (0, _styledComponents.css)(["", ";cursor:not-allowed;"], (0, _Link.linkColorStyles)(disabledFGColor, disabledFGColor, disabledFGColor))));
exports.StyledLink = StyledLink;

var withSizeModifiers = function withSizeModifiers(props) {
  var _props$size = props.size,
      size = _props$size === void 0 ? 'small' : _props$size;
  if (size === 'medium') return (0, _styledComponents.css)(["font-size:", ";padding:", ";"], (0, _rem.default)(_designTokens.typography.size.alias.header4), "".concat((0, _rem.default)(10), " ").concat((0, _rem.default)(30), " ").concat((0, _rem.default)(10), " ").concat((0, _rem.default)(10)));
  return (0, _styledComponents.css)(["font-size:", ";padding:", ";"], (0, _rem.default)(_designTokens.typography.size.alias.paragraph), "".concat((0, _rem.default)(5), " ").concat((0, _rem.default)(30), " ").concat((0, _rem.default)(5), " ").concat((0, _rem.default)(10)));
};

function getBorderRadius(_ref) {
  var borderRadius = _ref.borderRadius;
  return borderRadius || '2px';
}

var Container = _styledComponents.default.li.withConfig({
  displayName: "styles__Container",
  componentId: "sc-1vr9h8x-1"
})(["text-align:left;&:focus{outline:none;}> .label,> ", "{align-items:center;border:1px solid transparent;color:", ";display:flex;pointer-events:none;width:100%;white-space:nowrap;", " > *{margin-right:", ";}}> ", "{pointer-events:auto;background-color:transparent;text-decoration:none;}&:first-child > .label,&:first-child > ", "{border-top-left-radius:", ";border-top-right-radius:", ";}&:last-child > .label,&:last-child > ", "{border-bottom-left-radius:", ";border-bottom-right-radius:", ";}&:hover:not([aria-disabled='true']):not([aria-selected='true']) > .label,&:hover:not([aria-disabled='true']):not([aria-selected='true']) > ", "{color:", ";text-decoration:none;.label > *{border-color:", ";}}&[aria-selected='true'] > .label{background:", ";color:", ";}&[aria-selected='true'] > .label > div > #optionLabelDetails{background:", ";color:", ";}", ";", " &[aria-disabled='true']{cursor:not-allowed;", "{pointer-events:none;}}&[aria-disabled='true'] > .label,&[aria-disabled='true'] > ", "{background:", ";color:", ";}"], StyledLink, (0, _toColorString.default)(_designTokens.color.interaction.pacificOcean), withSizeModifiers, (0, _rem.default)(10), StyledLink, StyledLink, getBorderRadius, getBorderRadius, StyledLink, getBorderRadius, getBorderRadius, StyledLink, (0, _toColorString.default)(_designTokens.color.interaction.pacificOcean), (0, _toColorString.default)(_designTokens.color.interaction.indianOcean), (0, _toColorString.default)(_designTokens.color.interaction.pacificOcean), (0, _toColorString.default)(_designTokens.color.base.snowWhite), (0, _toColorString.default)(_designTokens.color.interaction.pacificOcean), (0, _toColorString.default)(_designTokens.color.base.snowWhite), (0, _styleModifiers.when)('isActive', (0, _styledComponents.css)(["color:", ";background:", ";.label > *{border-color:", ";}"], (0, _toColorString.default)(_designTokens.color.interaction.pacificOcean), (0, _toColorString.default)(_designTokens.color.interaction.pacificOcean15), (0, _toColorString.default)(_designTokens.color.interaction.indianOcean))), (0, _styleModifiers.when)([['isActive'], ['inputMethod', 'keyboard']], (0, _styledComponents.css)(["background:none;> .label,> ", "{border-color:", ";", "}&[aria-selected='true'] > .label,&[aria-selected='true'] > ", "{color:", ";", "}"], StyledLink, (0, _toColorString.default)(_designTokens.color.interaction.pacificOcean), (0, _focusRingWithColor.default)(_designTokens.color.interaction.pacificOcean40), StyledLink, (0, _toColorString.default)(_designTokens.color.base.snowWhite), (0, _focusRingWithColor.default)(_designTokens.color.opacity.fullMoon50))), StyledLink, StyledLink, (0, _toColorString.default)(_designTokens.color.base.snowWhite), (0, _toColorString.default)(_designTokens.color.opacity.charcoal40));

exports.Container = Container;

var StyleLabelWrapper = _styledComponents.default.div.withConfig({
  displayName: "styles__StyleLabelWrapper",
  componentId: "sc-1vr9h8x-2"
})(["display:flex;flex:1;flex-direction:column;"]);

exports.StyleLabelWrapper = StyleLabelWrapper;

var DecorationComponentContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__DecorationComponentContainer",
  componentId: "sc-1vr9h8x-3"
})(["", ";"], (0, _styleModifiers.when)('disabled', (0, _styledComponents.css)(["opacity:0.3;img{opacity:0.3;}"])));

exports.DecorationComponentContainer = DecorationComponentContainer;
var StyledLabel = (0, _styledComponents.default)(_Typography.P).attrs({
  as: 'span',
  color: 'inherit'
}).withConfig({
  displayName: "styles__StyledLabel",
  componentId: "sc-1vr9h8x-4"
})(["font-size:inherit;"]);
exports.StyledLabel = StyledLabel;
var StyledLabelDetails = (0, _styledComponents.default)(_Typography.P).attrs({
  as: 'span',
  shade: 1
}).withConfig({
  displayName: "styles__StyledLabelDetails",
  componentId: "sc-1vr9h8x-5"
})([""]);
exports.StyledLabelDetails = StyledLabelDetails;